import { Draggable } from '@hello-pangea/dnd';
import { PriorityBadge } from '../priority-badge';
import { CategoryBadge } from '../category-badge';
import type { Task } from '@/lib/types';
import { Calendar, User } from 'lucide-react';
import { useState } from 'react';
import { TaskDetailsModal } from '../task-details/task-details-modal';
import { formatDate } from '@/lib/utils/timezone';

interface KanbanTaskProps {
  task: Task;
  index: number;
}

export function KanbanTask({ task, index }: KanbanTaskProps) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <Draggable draggableId={task.id} index={index}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 hover:shadow-md transition-shadow cursor-pointer"
            onClick={() => setShowDetails(true)}
          >
            <div className="space-y-3">
              <div className="flex items-start justify-between gap-2">
                <h4 className="font-medium">{task.title}</h4>
                <PriorityBadge priority={task.priority} />
              </div>

              {task.description && (
                <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-2">
                  {task.description}
                </p>
              )}

              <div className="flex flex-wrap gap-2">
                <CategoryBadge category={task.category} />
                
                {task.owner && (
                  <div className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
                    <User className="w-4 h-4" />
                    <span>{task.owner.full_name}</span>
                  </div>
                )}

                {task.due_date && (
                  <div className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
                    <Calendar className="w-4 h-4" />
                    <span>{formatDate(task.due_date)}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Draggable>

      {showDetails && (
        <TaskDetailsModal
          task={task}
          onClose={() => setShowDetails(false)}
        />
      )}
    </>
  );
}